export class QuotationValidator {
  static validate(quotationData: any, t: any): string[] {
    const validationErrors: string[] = [];

    if (!quotationData.customer) {
      validationErrors.push(t("Customer"));
    }

    if (!quotationData.contact) {
      validationErrors.push(t("Contact"));
    }

    if (!quotationData.technician) {
      validationErrors.push(t("Technician"));
    }

    if (!quotationData.date) {
      validationErrors.push(t("Date"));
    }

    if (!quotationData.duration) {
      validationErrors.push(t("Duration"));
    }

    return validationErrors;
  }
}
